import template from './ko-field-view-json.html';

class JSONViewComponentVM
{
	constructor(params)
	{
		this.params = params;
		this.value = ko_helper.safe_observable(params.value);
		this.extra_classes = ko_helper.safe_observableArray(params.extra_classes || []);

		// Create a computed observable that formats the JSON
		this.formattedValue = ko.computed(() => {
			const value = this.value();
			if (!value) return '';
			
			try {
				// If it's already a string, try to parse it first
				const obj = typeof value === 'string' ? JSON.parse(value) : value;
				return JSON.stringify(obj, null, 2);
			} catch (err) {
				return String(value);
			}
		});
	}
}

export default {
	name: 'ko-field-view-json',
	viewModel: JSONViewComponentVM,
	module_type: 'ko',
	template: template
} 